import { ITime } from './time';

export enum FlightType {
    Arrival = 'Arrival',
    Departure = 'Departure',
    TowInMovement = 'TowInMovement',
    TowOutMovement = 'TowOutMovement'
}

export enum FlightTypeIcon {
    FlightLand = 'flight_land',
    FlightTakeoff = 'flight_takeoff',
    FlightTowIn = 'flight_tow_in',
    FlightTowOut = 'flight_tow_out'
}

export interface IFlight {
    stand: string;
    centerline: string;
    flightNumber: string;
    flightType: FlightType;
    acType: string;
    time: ITime;
}
